import { render, staticRenderFns } from "./ReviewHistoryKompetensi.vue?vue&type=template&id=58f3d0b2&scoped=true&lang=html&"
import script from "./ReviewHistoryKompetensi.vue?vue&type=script&lang=js&"
export * from "./ReviewHistoryKompetensi.vue?vue&type=script&lang=js&"
import style0 from "./ReviewHistoryKompetensi.vue?vue&type=style&index=0&id=58f3d0b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f3d0b2",
  null
  
)

export default component.exports